export type { AlsoAvailableOnSectionHeaderProps } from './AlsoAvailableOnSectionHeader';
export { AlsoAvailableOnSectionHeader } from './AlsoAvailableOnSectionHeader';
